export const ZONE_TYPE_LABELS = {
  STATE: 'State',
  CITY: 'City',
  COUNTY: 'County',
  MUNICIPALITY: 'Municipality',
  ZIP_CODE: 'ZIP Code',
  TOWNSHIP: 'Township',
  SPECIAL_DISTRICT: 'Special District',
}

export const REMITTANCE_FREQUENCY_LABELS = {
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
  annual: 'Yearly',
  annually: 'Yearly',
}

export const RATE_TYPE_OPTIONS = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'flat', label: 'Flat dollar amount' },
]

export const REMITTANCE_FREQUENCY_OPTIONS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'yearly', label: 'Yearly' },
]

export const INVOICE_GROUPING_OPTIONS = [
  {
    value: 'consolidated',
    label: 'Consolidated by tax',
    description: 'One line per tax at the invoice footer.',
  },
  {
    value: 'consolidatedAll',
    label: 'Consolidated, all taxes',
    description: 'Every tax set this way shares one footer line, named "Taxes".',
  },
  {
    value: 'itemized',
    label: 'Itemized',
    description: 'A separate tax line under each taxable line item.',
  },
  {
    value: 'groupedByService',
    label: 'Grouped by service',
    description: 'Taxes aggregated into one line per service on the invoice.',
  },
  {
    value: 'groupedByLocation',
    label: 'Grouped by location',
    description: 'Taxes aggregated into one line per location on the invoice.',
  },
]
